/**
 * Switch for the fridge type without dish RFID readers (`?flow=nonRfid`). Read from the URL only, in every
 * build, production included: the kiosk's configured URL carries it, and the playground passes it on every
 * reload. The backend capability flag replaces it once it exists.
 */
export const isNonRfidFlow = (): boolean => new URLSearchParams(window.location.search).get("flow") === "nonRfid";
